import { useEffect, useState } from "react";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Dialog from "@mui/material/Dialog";
import { Typography } from "@mui/material";
import Button from "@mui/material/Button";
import { insertProductDetail } from "../../../http/api/ProductDetailAPI";
import useInputObject from "../../../hooks/useInputObject";
import ProductDetailInfo from "../../../pages/product/ProductDetailInfo/ProductDetailInfo";

const onFocusInput = (event) => {
  event.target.select();
};

// 商品明細マスター追加ダイアログ
export default function AddProductDetailMasterDialog({
  open,
  onClose,
  productData,
  openAddProductDialog,
}) {

  const productDetailDataInput = useInputObject({});

  // 商品情報追加中をあらわすstate
  const [isAdding, setAdding] = useState(false);
  
  //商品明細情報を取得
  useEffect(() => {
    setAdding(false);
    productDetailDataInput.setValue({});

    if (open && productData) {

      initializeProductDetailInfo(productData);
    }

  }, [open]);

  const initializeProductDetailInfo = (productData) => {
    productDetailDataInput.setValue({productId: productData.productId, productName: productData.productName});
  }


  const onClickAdd = async (event) => {
    setAdding(true);
    productDetailDataInput.Value.createdId = 1; //TODO JWTを追加した後削除
    productDetailDataInput.Value.updatedId = 1; //TODO JWTを追加した後削除
    
    let newProductDetailId = await insertProductDetail(productDetailDataInput.Value);
    console.log(newProductDetailId)

    openAddProductDialog({
      ...productData, ...productDetailDataInput.Value,
      productDetailId: newProductDetailId,
    });  
  }

  const onClickReturn = (event) => {
    openAddProductDialog({
      ...productData,
      productDetailId : null,
      origin: "",
      displaySize: "",
      orderingUnit: "",
    });
  }

  return (
    <Dialog open={open} onClose={onClose} maxWidth={false} PaperProps={{maxHeight : "calc(100%-20px)"}}>
      <Box padding={2}>
        <Typography fontSize={20} fontWeight={700}>
          商品明細マスタ追加
        </Typography>
        {
          open
            ? <ProductDetailInfo productId={productData.productId} productDetail={productDetailDataInput} />
            : null
        }        
        <Grid container marginTop={2}>
          <Grid item xs textAlign="center">
            <Button
              variant="contained"
              color="error"
              onClick={onClickAdd}
              disabled={isAdding}
            >
              追加
            </Button>
          </Grid>
          <Grid item xs textAlign="center">
            <Button variant="outlined" onClick={onClickReturn}>
              戻る
            </Button>
          </Grid>
        </Grid>
      </Box>
    </Dialog>
  );
}
